import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import moment from "moment";
import store from "@/core/services/store";
import AuthService from "@/core/services/auth.service";
import ApiService from "@/core/services/api.service";
import auth from "@/core/services/store/auth.module";
import {LOGOUT} from "@/core/services/store/auth.module";
// import MockService from "@/core/mock/mock.service";
import {VERIFY_AUTH} from "@/core/services/store/auth.module";
import {RESET_LAYOUT_CONFIG} from "@/core/services/store/config.module";
import Editor from "@tinymce/tinymce-vue";
import {quillEditor} from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";

window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";

window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
// import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import {getToken} from "./core/services/jwt.service";
import * as VueGoogleMaps from "vue2-google-maps"; // Import package

// import mixins
import globalMixin from "./mixins/globalMixin";
import templates from "./mixins/templates";
import './registerServiceWorker'
import { initBrowserRestrictions } from "@/utils/browserRestrictions";
import { escapeHtml, sanitizeRichHtml, sanitizeRichHtmlExcerpt } from "@/utils/sanitizeHtml";

initBrowserRestrictions();

Vue.prototype.$escapeHtml = escapeHtml;
Vue.prototype.$sanitizeRichHtml = sanitizeRichHtml;
Vue.prototype.$sanitizeRichHtmlExcerpt = sanitizeRichHtmlExcerpt;
Vue.directive("safe-html", {
    bind(el, binding) {
        el.textContent = binding.value == null ? "" : String(binding.value);
    },
    update(el, binding) {
        el.textContent = binding.value == null ? "" : String(binding.value);
    }
});

Vue.component("editor", Editor);
Vue.component("quillEditor", quillEditor);
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDrZwhpOkdT45MVENIJlF8fG-ppGPHqYpU",
        libraries: "places"
    }
});
Vue.mixin(globalMixin);
Vue.mixin(templates);
ApiService.init();
// Remove this to disable mock API
// MockService.init();

const PUBLIC_ROUTE_NAMES = new Set([
    "login",
    "ghost-login",
    "forgot-password",
    "reset-password",
    "area-report",
    "ads-area-report",
    "listing-price-report",
    "reservation-form",
    "spa-form",
    "noc-form",
    "404",
    "error-1",
    "error-2",
    "error-3",
    "error-4",
    "error-5",
    "error-6",
]);

const AUTH_PAGE_NAMES = new Set([
    "login",
    "ghost-login",
    "forgot-password",
    "reset-password",
]);

function isPublicRoute(to) {
    if (PUBLIC_ROUTE_NAMES.has(to.name)) {
        return true;
    }

    return !to.meta || !to.meta.auth;
}

router.beforeEach((to, from, next) => {
    store.dispatch(RESET_LAYOUT_CONFIG);

    if (!getToken() && auth.state.isAuthenticated) {
        store.dispatch(LOGOUT).then(() => next({ name: "login" }));
        return;
    }

    if (isPublicRoute(to)) {
        // Never block login/auth pages on verify (e.g. API maintenance / 503).
        if (getToken() && !AUTH_PAGE_NAMES.has(to.name)) {
            store.dispatch(VERIFY_AUTH, to.name).finally(() => next());
        } else {
            next();
        }
        return;
    }

    if (!getToken()) {
        next({ name: "login" });
        return;
    }

    store.dispatch(VERIFY_AUTH, to.name)
        .then(data => {
            if (data && data._metadata && data._metadata.outcomeCode === 0) {
                if (AuthService.hasPermission(to.meta.permission)) {
                    next();
                } else {
                    next({ name: "login" });
                }
            } else {
                next({ name: "login" });
            }
        })
        .catch(() => {
            if (getToken()) {
                next();
                return;
            }
            next({ name: "login" });
        });

    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
});

export const bus = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
